import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '../../components/form';
import { getImagePath } from '../../utils';

const approvedSVG = getImagePath('ic_approved.svg');

export const SubscriptionCompletedModal = ({
  open,
  onToggle: handleToggle
}) => (
  <Modal
    className="crm-modal"
    isOpen={open}
    toggle={handleToggle}
    fade={false}
    centered
  >
    <ModalBody>
      <div className="PaymentStatus">
        <div className="PaymentStatus__main">
          <img
            className="PaymentStatus__img"
            src={approvedSVG}
            alt="modal payment status"
          />

          <span className="PaymentStatus__title PaymentStatus--muted">
            <FormattedMessage
              id="PaymentStatus.subscription.messages.completed.title"
            />
          </span>

          <span className="PaymentStatus__subtitle PaymentStatus--muted">
            <FormattedMessage
              id="PaymentStatus.subscription.messages.completed.body"
            />
          </span>

          <Button className="forms-Button" type="button" onClick={handleToggle}>
            <FormattedMessage
              id="PaymentStatus.subscription.buttons.completed.submit"
            />
          </Button>
        </div>
      </div>
    </ModalBody>
  </Modal>
);

SubscriptionCompletedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

